import { cssVar } from '@chakra-ui/react';
import { BadgesSchema } from './Badges.styles';

const $arrowBg = cssVar('popper-arrow-bg');
export const badgeStyles: BadgesSchema = {
  flexIconWrapper: {
    bgGradient: 'linear(to-b, beta.200, beta.400)',
    boxShadow:
      '0px 0px 1px 0px rgba(255, 255, 255, 0.15) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    h: '7',
    borderRadius: 'base',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    gap: '1',
    p: '1',
    w: '75px',
  },
  iconBadge: {
    color: 'blackAlpha.800',
    boxSize: '4',
    filter: 'drop-shadow(0px 1px 0px rgba(255, 255, 255, 0.25))',
    sx: {
      '&&': {
        path: {
          fill: 'blackAlpha.800',
        },
      },
    },
  },
  iconTitle: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    lineHeight: '1',
    color: 'blackAlpha.800',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.25)',
    textAlign: 'left',
  },
  textTitle: {
    textTransform: 'uppercase',
    fontWeight: 'extrabold',
    fontSize: '2xs',
    color: 'gray.700',
  },
  textDescription: {
    fontSize: '2xs',
    color: 'gray.700',
    fontWeight: 'normal',
  },
  tabs: {
    w: 'full',
    mt: '1',
  },
  tabPanels: {
    mt: '2',
  },
  tooltipWrapper: {
    borderRadius: 'md',
    p: '2',
    pr: '4',
    display: 'block',
    position: 'relative',
    bg: 'white',
    [$arrowBg.variable]: 'var(--bc-colors-alpha-500)',
    fontFamily: 'body',
  },
  tabPanelWrapper: {
    bg: 'alpha.500',
    borderRadius: 'md',
    fontSize: 'xs',
    w: 'full',
    sx: {
      p: {
        p: '2',
        color: 'white',
      },
    },
  },
  tabBadge: {
    position: 'relative',
    p: '0',
    pr: '1',
    mr: '1',
    border: 'none',
    color: 'alpha.500',
    _selected: {
      border: 'none',
      '&::after': {
        content: "''",
        position: 'absolute',
        left: '0',
        right: '0',
        margin: 'auto',
        bottom: '-12px',
        width: '5',
        height: '5',
        borderLeft: '10px solid transparent',
        borderRight: '10px solid transparent',
        borderTop: '10px solid var(--bc-colors-alpha-500)',
        transform: 'rotate(180deg)',
        clear: 'both',
        zIndex: ['unset', null, 'popover'],
      },
    },
  },
};
